<template>
	<div :id="this.id"></div>
</template>

<script>
	export default {
		name: "SimpleGauge",
		props: {
			id:"",
			titleText: "",
			seriesName: "",
			seriesMax: 0,
			seriesDataValue: 0,
			seriesDataName: "",
		},
		methods: {
			draw() {
				let newPromise = new Promise((resolve) => {
					resolve()
				})
				newPromise.then(() => {
					this.$echarts.dispose(document.getElementById(this.id));
					var myChart = this.$echarts.init(document.getElementById(this.id));

					var option = {
						title: {
							text: this.titleText,
							left: 'center',
						},
						tooltip: {},
						series: [{
							name: this.seriesName,
							type: 'gauge',
							progress: {
								show: true
							},
							detail: {
								valueAnimation: true,
								formatter: '{value}'
							},
							max:this.seriesMax,
							data: [{
								value: this.seriesDataValue,
								name: this.seriesDataName,
							}]
						}]
					};

					myChart.setOption(option);
				})
			}
		},
		watch: {
			seriesDataValue: {
				handler(val, oldVal) {
					this.draw();
				},
				deep: true,
				immediate: true,
			},
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ECharts/SimpleGauge.vue